export default __webpack_public_path__ + "f7ae2abaf5bafd6b1997932015b90335.svg";